import { ChangeDetectorRef, Component, Input, inject, output, OutputEmitterRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AutocompleteDataSource } from '@app/shared/ui/components/inputs/autocomplete/autocomplete.helper';
import { AutocompleteVersion } from '@app/shared/enums/general.enums';

@Component({
	selector: 'contacts-search-form',
	templateUrl: './contacts-search-form.component.html',
	styleUrls: ['./contacts-search-form.component.scss'],
	standalone: false
})
export class ContactsSearchFormComponent {
	private cdr = inject(ChangeDetectorRef);

	@Input() set formData(val: Record<string, any>) {
		if (val) {
			this.fillFormWithInitialData(val);
		}
	}
	readonly submit: OutputEmitterRef<Record<string, any>> = output<Record<string, any>>();

	public readonly autocompleteDataSource: typeof AutocompleteDataSource = AutocompleteDataSource;
	public readonly autocompleteVersion: typeof AutocompleteVersion = AutocompleteVersion;

	public readonly CLIENT_CONTROL_NAME: string = 'client';
	public readonly CONTACT_NAME_CONTROL_NAME: string = 'contactName';
	public readonly COMPANY_NAME_CONTROL_NAME: string = 'companyName';
	public readonly TAX_ID_NAME_CONTROL_NAME: string = 'taxId';
	public readonly DEPARTMENT_CONTROL_NAME: string = 'departmentName';
	public readonly POSITION_CONTROL_NAME: string = 'position';
	public readonly EMAIL_CONTROL_NAME: string = 'email';
	public readonly PHONE_CONTROL_NAME: string = 'phoneNumber';
	public readonly FAX_CONTROL_NAME: string = 'fax';
	public readonly ADDRESS_CONTROL_NAME: string = 'address';

	public formGroup: UntypedFormGroup = new UntypedFormGroup({
		[this.CLIENT_CONTROL_NAME]: new UntypedFormControl(),
		[this.CONTACT_NAME_CONTROL_NAME]: new UntypedFormControl(),
		[this.COMPANY_NAME_CONTROL_NAME]: new UntypedFormControl(),
		[this.TAX_ID_NAME_CONTROL_NAME]: new UntypedFormControl(),
		[this.DEPARTMENT_CONTROL_NAME]: new UntypedFormControl(),
		[this.POSITION_CONTROL_NAME]: new UntypedFormControl(),
		[this.EMAIL_CONTROL_NAME]: new UntypedFormControl(),
		[this.PHONE_CONTROL_NAME]: new UntypedFormControl(),
		[this.FAX_CONTROL_NAME]: new UntypedFormControl(),
		[this.ADDRESS_CONTROL_NAME]: new UntypedFormControl()
	});

	private fillFormWithInitialData(data: Record<string, any>): void {
		Object.keys(data).forEach((key: string) => {
			if (this.formGroup.contains(key)) {
				this.formGroup.get(key).setValue(data[key]);
			}
		});
	}

	private submitForm(): void {
		this.submit.emit(this.formGroup.value);
	}

	public onClearAll(): void {
		this.formGroup.reset();
	}

	public onSubmit(): void {
		if (this.formGroup.valid) {
			this.submitForm();
		} else {
			this.formGroup.markAllAsTouched();
			this.cdr.markForCheck();
		}
	}
}
